import { fetchPaymentHistory } from '../../../services/api/finance';
import { naturalCompare } from '../../../helpers';

function getTableValue(request, key) {
    switch (key) {
        default:
            return request[key];
    }
}

export const paymentHistory = {
    namespaced: true,
    state: {
        display: 10,
        page: 1,
        sort: {
            column: 'datetime',
            order: 'desc',
        },
        history: [],
    },
    mutations: {
        save(state, data) {
            state.history = data;
        },
        add(state, record) {
            state.history.push(record);
        },
        setPage(state, page) {
            state.page = page;
        },
        setSort(state, sort) {
            state.sort = sort;
        },
        resetState(state) {
            state.page = 1;
            state.costs = [];
        }
    },
    actions: {
        fetchHistory({ commit, dispatch }) {
            return fetchPaymentHistory()
                .then((res) => {
                    commit('save', res.data);

                    return Promise.resolve(res);
                })
                .catch((res) => {
                    dispatch('error', res, { root: true });

                    return Promise.reject(res);
                });
        },
        addRecord({ commit }, record) {
            commit('add', record);
        },
        setPage({ commit }, page) {
            commit('setPage', page);
        },
        setSort({ commit }, sort) {
            commit('setSort', sort);
        },
        resetState({ commit }) {
            commit('resetState');
        }
    },
    getters: {
        totalRecords({ history }) {
            return history.length;
        },
        sortedRecords({ history, sort }) {
            const sorted = history.sort((a, b) => {
                return naturalCompare(
                    getTableValue(a, sort.column),
                    getTableValue(b, sort.column));
            });

            return sort.order === 'asc'
                ? sorted
                : sorted.reverse();
        },
        paginatedRecords({ page, display }, { sortedRecords }) {
            return sortedRecords.slice((page - 1) * display, page * display);
        },
    }
};



// WEBPACK FOOTER //
// ./src/modules/home/paymentHistory/store.js